import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurtainsClosedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"curtains_closed"}/>
}
